import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import io from 'socket.io-client'
import VueLodash from 'vue-lodash'
import includes from 'lodash/includes'

import '@/assets/scss/style.scss'

const socket = io('http://api.bergregions.pl:9092/')

Vue.prototype.$socket = socket

Vue.config.productionTip = false

Vue.use(VueLodash, { name: 'custom', lodash: { includes } })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// WebSockets
socket.on('connect', () => {
  store.dispatch('device/socket_connect')
  store.commit('device/SOCKET_CONNECT')
})
socket.on('device', data => {
  store.dispatch('device/socket_device', data)
})
